import React from 'react'
import Navbar from '../components/Navbar/Navbar'
import GalleryHero from '../components/gallery/Hero/GalleryHero'
import GalleryContent from '../components/gallery/GalleryContent/GalleryContent'
import Footer from '../components/Footer/Footer'

export default function Gallery() {
    return (
        <>
          <Navbar/>
          <GalleryHero/>
            <GalleryContent/>
          <Footer/>  
        </>
    )
}
